import { render, staticRenderFns } from "./term2.vue?vue&type=template&id=7f6a47b6&"
import script from "./term2.vue?vue&type=script&lang=js&"
export * from "./term2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports